import { render, staticRenderFns } from "./currentDay.vue?vue&type=template&id=28d3002a&scoped=true"
import script from "./currentDay.vue?vue&type=script&lang=js"
export * from "./currentDay.vue?vue&type=script&lang=js"
import style0 from "./currentDay.vue?vue&type=style&index=0&id=28d3002a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d3002a",
  null
  
)

export default component.exports